import { Grid, Box, makeStyles } from "@material-ui/core";
import { Edit } from "react-admin";
import ImageChanger from "./ImageChanger";
const useStyles = makeStyles((theme) => ({
  height100: {
    height: "100%",
    marginTop: 0,
  },
}));
const RightGridEdit = (props) => {
  const { resource, noImage, customComponent } = props;
  const classes = useStyles();
  return (
    <Grid item xs={4} style={{ height: "100%" }}>
      <Box style={{ height: "100%" }}>
        <Edit
          style={{ height: "100%" }}
          classes={{ main: classes.height100 }}
          actions={null}
          mutationMode="pessimistic"
          onSuccess={null}
          onFailure={null}
          transform={null}
          {...props}
        >
          <>
            <ImageChanger
              resource={resource}
              noImage={noImage}
              customComponent={customComponent}
            />
          </>
        </Edit>
      </Box>
    </Grid>
  );
};

export default RightGridEdit;
